/* ============================================================
   tokusetsu.js — 父の日特集ページ
   Crazy Ferret Father's Day 2026
   ============================================================ */

// ============================================================
// ★ 設定
// ============================================================
// ★ 変更：Liquidで渡された window.CSV_URL を使用（assets/tokusetsu.csv）
const CSV_URL = (typeof window.CSV_URL !== 'undefined') ? window.CSV_URL : "";

// タイプ別カラー（テキストバー・矢印バーに適用）
const TYPE_COLORS = {
  "1": "#ada013",
  "2": "#ce8e4f",
  "3": "#be6264",
  "4": "#6282be",
  "5": "#b462be",
  "6": "#7c9759",
  "7": "#13ad99",
};

const TYPE_COLORS_LIGHT = {
  "1": "#e8e29a",
  "2": "#f0d4b0",
  "3": "#e8b8b9",
  "4": "#b8c8e8",
  "5": "#e0b8e8",
  "6": "#c8d9b0",
  "7": "#9ae8de",
};

/* ============================================================
   ⑥-A 大ブランド設定
   ---- ここから大ブランドの追加・削除・編集 ----
   ============================================================ */
const BIG_BRANDS = [
  {
    id:"calvin-klein", label:"Calvin Klein", en:"カルバンクライン",
    desc:"世界的ファッションブランドCalvin Kleinのアンダーウェアは、シンプルで洗練されたデザインが特徴。毎日身につけるものだからこそ、ブランドの品質とスタイルを贈り物に。",
    more:"https://topfloor.jp/collections/brand-crazyferret?sort_by=best-selling&filter.p.m.custom._sexunder=%E3%83%A1%E3%83%B3%E3%82%BA&filter.p.vendor=Calvin+Klein&filter_by_price=0%3B26400&filter.v.price.gte=&filter.v.price.lte="
  },
  {
    id:"paul-smith", label:"Paul Smith", en:"ポールスミス",
    desc:"英国を代表するデザイナーズブランドPaul Smithのアンダーウェアは、遊び心あるストライプや豊かなカラーリングが魅力。センスあるパパへの特別なギフトに。",
    more:"https://topfloor.jp/collections/brand-crazyferret?sort_by=best-selling&filter.p.m.custom._sexunder=%E3%83%A1%E3%83%B3%E3%82%BA&filter.p.vendor=Paul+Smith&filter_by_price=0%3B26400&filter.v.price.gte=&filter.v.price.lte="
  },
  {
    id:"polo-ralph-lauren", label:"POLO RALPH LAUREN", en:"ポロ ラルフローレン",
    desc:"アメリカンクラシックの代名詞POLO RALPH LAUREN。アイコニックなポニーロゴとこだわりの素材感は、父の日ギフトとして喜ばれる定番中の定番。",
    more:"https://topfloor.jp/collections/brand-crazyferret?sort_by=best-selling&filter.p.m.custom._sexunder=%E3%83%A1%E3%83%B3%E3%82%BA&filter.p.vendor=POLO+RALPH+LAUREN&filter_by_price=0%3B26400&filter.v.price.gte=&filter.v.price.lte="
  },
  {
    id:"emporio-armani", label:"EMPORIO ARMANI", en:"エンポリオ アルマーニ",
    desc:"イタリアを代表するラグジュアリーブランドEMPORIO ARMANIのアンダーウェア。上質なマイクロファイバーと洗練されたデザインは、こだわりのあるパパへの最高の贈り物。",
    more:"https://topfloor.jp/collections/brand-crazyferret?sort_by=best-selling&filter.p.m.custom._sexunder=%E3%83%A1%E3%83%B3%E3%82%BA&filter.p.vendor=EMPORIO+ARMANI&filter_by_price=0%3B26400&filter.v.price.gte=&filter.v.price.lte="
  },
  {
    id:"betones", label:"BETONES", en:"ビトーンズ",
    desc:"日本発のユニークなデザインで人気のBETONES。ユーモアあふれるプリントと鮮やかなカラーは、ちょっと個性的なパパへのサプライズギフトにぴったり。",
    more:"https://topfloor.jp/collections/brand-crazyferret?sort_by=best-selling&filter.p.m.custom._sexunder=%E3%83%A1%E3%83%B3%E3%82%BA&filter.p.vendor=BETONES&filter_by_price=0%3B26400&filter.v.price.gte=&filter.v.price.lte="
  },
  /* ---- 大ブランドを追加する場合はここに追記 ----
  {
    id:"brand-id",        // ← CSV の section_id と合わせる
    label:"ブランド名",
    en:"カタカナ表記",
    desc:"ブランド説明文",
    more:"https://...もっと見るURL..."
  },
  ---- 追加ここまで ---- */
];
/* ============================================================
   大ブランド設定ここまで
   ============================================================ */

const TYPES = [
  { id:"1", label:"ザ・ソファ王" },
  { id:"2", label:"素材こだわり探求家" },
  { id:"3", label:"自称アスリートパパ" },
  { id:"4", label:"隠れオシャレパパ" },
  { id:"5", label:"柄物レジェンド" },
  { id:"6", label:"「なんでもいい」の申し子" },
  { id:"7", label:"ザ・コスパ番長" },
];

const CATEGORIES = [
  { id:"underwear", label:"アンダーウェア" },
  { id:"inner",     label:"インナー系" },
  { id:"tshirt",    label:"Tシャツ・ロンT" },
  { id:"socks",     label:"ソックス・小物" },
];

// ============================================================
let allItems = [];

async function loadCSV() {
  try {
    const res = await fetch(CSV_URL);
    const csv = await res.text();
    const rows = csv.trim().split("\n").slice(1);
    allItems = rows.map(row => {
      const cols = row.split(",");
      return {
        section:       cols[0]?.trim(),
        section_id:    cols[1]?.trim(),
        section_label: cols[2]?.trim(),
        brand:         cols[3]?.trim(),
        name:          cols[4]?.trim(),
        price:         `¥${parseInt(cols[5]).toLocaleString()}`,
        image_url:     cols[6]?.trim(),
        item_url:      cols[7]?.trim(),
        free:          cols[8]?.trim().toUpperCase() === "TRUE",
        more_url:      cols[9]?.trim(),
      };
    }).filter(r => r.section);
  } catch(e) {
    console.warn("CSV読み込み失敗:", e);
  }
  buildPage();
}

function getItems(section, id) {
  return allItems.filter(r => r.section === section && r.section_id === id);
}
function getMoreUrl(section, id) {
  const item = allItems.find(r => r.section === section && r.section_id === id);
  return item?.more_url || "#";
}

// 商品カード（スライド用）
function cardSm(item) {
  return `<a class="item-card-sm" href="${item.item_url}">
    <img class="item-thumb-sm" src="${item.image_url}" alt="${item.name}" loading="lazy" onerror="this.style.display='none'"/>
    <div class="item-info-sm">
      <div class="item-brand-sm">${item.brand}</div>
      <div class="item-name-sm">${item.name}</div>
      <div class="item-price-sm">${item.price}</div>
      ${item.free ? '<div class="item-free-sm">送料無料</div>' : ''}
    </div>
  </a>`;
}

// 商品カード（グリッド用）
function cardGrid(item) {
  return `<a class="item-card" href="${item.item_url}">
    <img class="item-thumb" src="${item.image_url}" alt="${item.name}" loading="lazy" onerror="this.style.display='none'"/>
    <div class="item-info">
      <div class="item-brand">${item.brand}</div>
      <div class="item-name">${item.name}</div>
      <div class="item-price">${item.price}</div>
      ${item.free ? '<div class="item-free">送料無料</div>' : ''}
    </div>
  </a>`;
}

// スライドHTML
function buildSlide(items, slideId) {
  if (!items.length) return '<p style="padding:0 16px;font-size:13px;color:#aaa">商品を読み込めませんでした</p>';
  return `
    <div class="slide-wrap" id="sw-${slideId}">
      <button class="slide-arrow prev" onclick="slide('${slideId}',-1)" aria-label="前へ">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="slide-track" id="st-${slideId}" onscroll="updateDots('${slideId}')">
        ${items.map(cardSm).join('')}
      </div>
      <button class="slide-arrow next" onclick="slide('${slideId}',1)" aria-label="次へ">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>
    <div class="slide-dots" id="sd-${slideId}">
      ${items.map((_,i) => `<div class="slide-dot${i===0?' active':''}" data-i="${i}"></div>`).join('')}
    </div>`;
}

function slide(id, dir) {
  const track = document.getElementById(`st-${id}`);
  track.scrollBy({ left: dir * 165, behavior: 'smooth' });
}
function updateDots(id) {
  const track = document.getElementById(`st-${id}`);
  const dots = document.querySelectorAll(`#sd-${id} .slide-dot`);
  const idx = Math.round(track.scrollLeft / 160);
  dots.forEach((d, i) => d.classList.toggle('active', i === idx));
}

// ページ構築
function buildPage() {
  // ③ アコーディオン生成
  const accList = document.getElementById('accordion-list');
  if (accList) {
    accList.innerHTML = TYPES.map(t => {
      const items = getItems('type', t.id);
      const color = TYPE_COLORS[t.id] || "#25314c";
		const colorLight = TYPE_COLORS_LIGHT[t.id] || "#6a7a9c";
      return `
        <div class="accordion-item" id="acc-${t.id}">
          <div class="acc-visual">
            <img src="${window.IMG_BASE}type${t.id}.jpg" alt="${t.label}" />
          </div>
          <div class="acc-trigger-wrap" onclick="toggleAcc('${t.id}')">
            <div class="acc-text-bar" style="background-color:${colorLight}">
              <span>${t.label}におすすめアイテム</span>
            </div>
            <div class="acc-arrow-bar" style="background-color:${color}">
              <div class="arrow-fixed-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="accordion-body">
            ${buildSlide(items, `type-${t.id}`)}
          </div>
        </div>`;
    }).join('');
  }

  // ④ タブ
  const tabBar = document.getElementById('tab-bar');
  const tabPanels = document.getElementById('tab-panels');
  if (tabBar && tabPanels) {
    tabBar.innerHTML = CATEGORIES.map((c, i) =>
      `<button class="tab-btn${i===0?' active':''}" onclick="switchTab('${c.id}',this)">${c.label}</button>`
    ).join('');
    tabPanels.innerHTML = CATEGORIES.map((c, i) => {
      const items = getItems('category', c.id);
      const moreUrl = getMoreUrl('category', c.id);
      return `
        <div class="tab-panel${i===0?' active':''}" id="tab-${c.id}">
          <div class="item-grid">${items.map(cardGrid).join('')}</div>
          <a class="slide-more" href="${moreUrl}">${c.label}をもっと見る →</a>
        </div>`;
    }).join('');
  }

  // ⑥-A 大ブランド（説明文付き）
  const brandBigList = document.getElementById('brand-big-list');
  if (brandBigList) {
    brandBigList.innerHTML = BIG_BRANDS.map(b => {
      const items = getItems('brand', b.id);
      return `
        <div class="brand-big-item">
          <div class="brand-big-header">
            <div class="brand-big-top">
              <div>
                <div class="brand-big-name">${b.label}</div>
                <div class="brand-big-sub">${b.en}</div>
              </div>
              <a class="brand-big-more" href="${b.more}">もっと見る →</a>
            </div>
            <p class="brand-big-desc">${b.desc}</p>
          </div>
          ${buildSlide(items, `brand-${b.id}`)}
        </div>`;
    }).join('');
  }
}

function toggleAcc(id) {
  document.getElementById(`acc-${id}`).classList.toggle('open');
}

function switchTab(id, btn) {
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById(`tab-${id}`).classList.add('active');
}

const SEC_IDS = {
  type:     'sec-type',
  price:    'sec-price',
  category: 'sec-category',
  brand:    'sec-brand',
};
function scrollToSec(id, el) {
  if(event) event.preventDefault();
  document.querySelectorAll('.bar-item,.pc-nav-item').forEach(b => b.classList.remove('active'));
  if (el) el.classList.add('active');
  const target = document.getElementById(SEC_IDS[id]);
  if (target) target.scrollIntoView({ behavior:'smooth', block:'start' });
}

function scrollTop() {
  window.scrollTo({ top:0, behavior:'smooth' });
}

// ダブルタップ拡大防止
let lastTap = 0;
document.addEventListener('touchend', function(e) {
  const now = Date.now();
  if (now - lastTap < 300) e.preventDefault();
  lastTap = now;
}, { passive:false });

loadCSV();
